import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import TableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';

const CellAffiliateName = (props) => {
    const [affiliate, setAffiliate] = useState(null);

    useEffect(() => {
        props.affiliates.every((affiliate) => {
            if (affiliate.affiliate_id === props.affiliateId) {
                setAffiliate(affiliate);
                return false;
            }
            return true;
        });
    }, [props.affiliates, props.affiliateId, props.affiliateName]);

    return (
        <TableCell className="affiliate_name"><Typography noWrap={true}>
            {(affiliate)
                ? <>
                    {(!props.user.affiliate)
                        ? <Link to={`/users/${affiliate.username}/`}>{affiliate.affiliate_name}</Link>
                        : `${affiliate.affiliate_name}`
                    }
                </>
                : props.affiliateName
            }
        </Typography></TableCell>
    );
};

CellAffiliateName.propTypes = {
    affiliateId: PropTypes.number.isRequired,
    affiliateName: PropTypes.string.isRequired,
};

export default connect(
    (state) => ({
        user: state.auth.user,
        affiliates: state.affiliates,
    }),
    null
)(CellAffiliateName);
